const fn = {
  init: () => {
    if (window.location.hash) {
      fn.handleUrl()
    }
  },

  handleUrl: () => {
    const hashTarget = document.querySelector(window.location.hash)

    if (hashTarget) {
      const el = hashTarget.querySelector('[data-slide-toggle]')

      if (el) {
        const trigger = el.closest('[data-slide-toggle]')
        const target = document.getElementById(trigger.getAttribute('aria-controls'))

        if (trigger && target) {
          trigger.setAttribute('aria-expanded', 'true')
          trigger.parentNode.classList.add('is-active')
          target.classList.remove('hidden')
          target.style.display = null

          const otherTriggers = Array.from(
            document.querySelectorAll('[data-slide-toggle][aria-expanded="true"]')
          ).filter((x) => x !== trigger)

          if (otherTriggers.length) {
            otherTriggers.forEach((el) => {
              const otherTrigger = el
              const otherTarget = document.getElementById(otherTrigger.getAttribute('aria-controls'))

              otherTrigger.setAttribute('aria-expanded', 'false')
              otherTrigger.parentNode.classList.remove('is-active')
              otherTarget.classList.add('hidden')
              otherTarget.style.display = null
            })
          }
        }
      }
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
